import React, { useState } from "react"
import styled from "styled-components";

const StyledWarning = styled.div`
    position: sticky;
    top: 0;
    z-index: 9999;
    border-radius: 0px !important;
    opacity: 0.85;
    background-color: pink;
    color: darkred;
    margin: -20px;
    margin-bottom: 20px;
    text-align: center;
    padding: 0.5em;
    display: flex;
    align-items: center;
    gap: 1em;
    font-weight: bold;

    &> span {
      flex: 1;
      margin-left: calc(32px + 1em + 4px);
    }
}
`;

const StyledButton = styled.button`
    background: transparent;
    border: unset;
    width: 32px;
    height: 32px;
    padding: 0;
    // box-shadow: 3px 3px 0 #ff7a7a;
    line-height: 1;
    cursor: pointer;
    color: darkred;
    font-size: 1.5em;

    &:hover {
      background-color: darkred;
      color: pink;
    }
`

const warning = {
    en: "Warning: this website is archived and in maintance mode, outdated stuff ahead.",
    pt: "Aviso: este website está arquivado e em modo de manutenção, coisas desatualizadas adiante.",
}

const Warning = (props) => {
    const [visible, setVisible] = useState(true);

    const handleDismiss = () => {
        setVisible(false);
    }
    return (
        <>
        {visible &&
        <StyledWarning>
            <span>{warning[props.lang]}</span>
            <StyledButton onClick={handleDismiss}>✕</StyledButton>
        </StyledWarning>
        }
        </>
    )
}

export default Warning;
